<template>
	<div>
		<Wysiwyg
			v-model="text"
			@input="emitChangeEvent"
		/>
	</div>
</template>

<script>
import Wysiwyg from "@/vue/common/form/Wysiwyg.vue";
import {isEmptyOrNull} from "@/helper/String";

export default{
	components: {Wysiwyg},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		return {
			text: this.value?.text || '',
		};
	},

	methods: {
		emitChangeEvent ()
		{
			if (isEmptyOrNull(this.text))
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				text: this.text,
			})
		}
	}
}
</script>
